import makeStyles from '@mui/styles/makeStyles';

export const useClinicalNoteStyles = makeStyles((theme) => ({
    root: {},
    searchBar: {
        height: 55,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
    },
    header: {
        marginTop: -4,
        marginBottom: 6,
        gap: 8,
    },
    buttonsHeader: {
        display: 'flex',
        gap: 6,
    },
    buttonHeader: {
        display: 'flex',
        alignItems: 'center',
    },
    auditHistoryDialog: {
        height: '70vh',
        maxHeight: '70vh',
    },
    searchText: {
        height: 18,
    },
    notesContent: {
        marginRight: -10,
        paddingRight: 5,
    },
    type: {
        minWidth: 220,
        marginBottom: 5,
    },
    dialog: {
        background: theme.palette.background.default,
    },
    filterButton: {
        marginBottom: 15,
        marginTop: 15,
        borderRadius: 10,
        padding: '8px 8px 2px 8px',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.mode === 'light' ? 'black' : 'white',
        height: 35,
    },
    toggleGroup: {
        height: 30, marginRight: 10, width: '100%',
    },
    toggleButton: {
        width: '50%', fontSize: 10,
    },
    results: {
        fontSize: 12,
    },
    warning: {
        backgroundColor: theme.palette.warning.light,
        borderRadius: 5,
        fontWeight: 'bold',
        textAlign: 'center',
        padding: 10,
        color: '#000',
    },
    toggleRoot: {
        color: theme.palette.mode === 'dark' ? '#222222' : '#f3f3f4',
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#eff1f3',
        display: 'inline-block',
        width: '100%',
        padding: '5px !important',
    },
    toggleLabel: {
        color: theme.palette.mode === 'dark' ? '#ACAFB3' : '#222222',
        height: '25px !important',
        fontSize: 12,
        '&.icon': {
            fontSize: 10,
        },
        '&.Mui-disabled': {
            border: 'none',
        },
    },
    toggleSelected: {
        color: theme.palette.mode === 'dark' ? '#222222 !important' : '#ffffff !important',
        fontWeight: 700,
        backgroundColor: theme.palette.mode === 'dark' ? '#ffffff !important' : '#626466 !important',
    },
    divider: {
        margin: '5px 0',
    },
    palette: {
        display: 'flex',
        flexDirection: 'column',
    },
    bodyMapBackground: {
        backgroundColor: theme.palette.background.defaultBackground,
    },
    brushButton: {
        width: '99%',
        paddingLeft: 20,
        margin: 5,
        '&.selected': {
            backgroundColor: theme.palette.background.paperDarker,
        },
    },
    noteTitle: {
        fontSize: 12,
        fontWeight: 'bold',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    attendanceType: {
        width: '16px !important',
        height: '16px !important',
        borderRadius: '50%',
    },
    chipAttendance: {
        backgroundColor: theme.palette.mode === 'light' ? '#eff1f3' : '#ffffff',
        color: '#222222',
        fontWeight: 'bold',
        minWidth: 300,
        justifyContent: 'start',
        '& .MuiChip-avatar': {
            marginLeft: '0 10px',
        },
    },
    noteAdmissionRoot: {
        margin: '10px 0',
    },
    icon: {
        fontSize: '14px !important',
    },
}));